// src/core/auth/hooks/useLogin.js
import { tokenStorage } from '../../../shared/api/storage';
import { authApi } from '../api/authApi';

function unwrap(resp) {
  return resp?.data ?? resp;
}

export function useLogin() {
  return async function login(values) {
    const raw = await authApi.login(values);
    const r = unwrap(raw);

    // backend bazen status'u farklı isimle döndürebilir diye normalize
    const status = r?.status || r?.accountStatus || r?.authStatus;

    // ✅ ACTIVE ise token kaydet
    if (status !== 'PENDING_EMAIL') {
      const accessToken = r?.accessToken || r?.token || r?.access_token;
      const refreshToken = r?.refreshToken || r?.refresh_token;

      if (!accessToken) {
        // token yoksa: login "başarılı" görünse bile sonraki istekler 401 olur
        throw new Error(
          "Login başarılı görünüyor ama accessToken dönmedi. Backend login response'u kontrol et."
        );
      }

      tokenStorage.set({ accessToken, refreshToken });
    }

    return r;
  };
}
